import React, { memo } from "react";
import { Controller } from "react-hook-form";
import { FormControl, FormErrorMessage, FormLabel, Skeleton } from "@chakra-ui/react";
import { ReactSelectWithChakraStyle } from "../../atoms/ReactSelectWithChakraStyle";
import { useFetchCorporations } from "../../../hooks/corporations/useFetchCorporations";
import { SelectOption, NoOptionsMessageProps } from '../../../types/select';

type SelectCorporationProps = {
  control: any;
  errors: any;
  isLoading?: boolean;
  label?: string;
  name?: string;
  options: SelectOption[];
}

export const SelectCorporation: React.FC<SelectCorporationProps> = memo(({control, errors, isLoading, name = 'restaurant.corporation', label = '法人'}) => {
  const { corporations, isLoading: fetchLoading } = useFetchCorporations()
  if (fetchLoading||!corporations) return null
  const corporationOption = corporations.map((corporation) => ({
    value: corporation.id,
    label: corporation.name
  }));
  const corporationError = errors[name]?.message;
  return (
    <FormControl isInvalid={!!errors[name]} isRequired w='100%'>
      <FormLabel>
        {label}
      </FormLabel>
      <Skeleton isLoaded={!fetchLoading} w='100%' borderRadius={5}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <ReactSelectWithChakraStyle<SelectOption>
              noOptionsMessage={({inputValue}: NoOptionsMessageProps) => !inputValue && '法人が存在しません'}
              placeholder="選択"
              options={corporationOption}
              value={corporationOption?.find((x: SelectOption) => x.value === field.value)}
              onChange={(option: SelectOption | null) => field.onChange(option?.value)}
            />
          )}
        />
      </Skeleton>
      <FormErrorMessage>{corporationError}</FormErrorMessage>
    </FormControl>
  );
});